// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-view_badge__9tS0l","visible":"badge-view_visible__1yLwd"};